import * as React from "react";

import * as dates from "../../../reducers/changeTimePeriod";

export interface IMonthDayNumber {
    date: Date;
    numberOfEvents: number;
    onSetCurrentDate: (event: any) => any;
    onSetViewMode: (event: any) => any;
    isMobileMode?: boolean;
}

export const MonthDayNumber = (props: IMonthDayNumber) => {

    const setToDailyViewModeAndSetCurrentDateToThisDate = (e) => {
        props.onSetCurrentDate(e);
        props.onSetViewMode(e);
    };

    let ariaLabel = dates.formatMonthDay(props.date);
    ariaLabel += ", ";

    if (props.numberOfEvents < 1) {
        ariaLabel += "no events"; // TODO: need to internationalize this...
    } else if (props.numberOfEvents === 1) {
        ariaLabel += "one event"; // TODO: need to internationalize this...
    } else {
        ariaLabel += props.numberOfEvents.toString() + " events"; // TODO: need to internationalize this...
    }

    if (!props.isMobileMode) {
        return (
            <div className="CAL-V-MV-day">
                <a href="#!" tabIndex={-1} aria-label={ariaLabel} onClick={setToDailyViewModeAndSetCurrentDateToThisDate} data-value="DAILYLIST" className="excl-sc-2-4-4 notranslate" data-date={props.date}>{dates.getDayOfMonth(props.date)}</a>
            </div>
        );
    } else {
        return (
            <a href="#!" aria-label={ariaLabel} onClick={setToDailyViewModeAndSetCurrentDateToThisDate} data-value="DAILYLIST" className="excl-sc-2-4-4 notranslate" data-date={props.date}>
                <span> {dates.getDayOfMonth(props.date)}</span>
            </a>
        );
    }

};
